// extracted by mini-css-extract-plugin
export default {"container":"ticket_container__1C0gg","left":"ticket_left__1VKDD","icon":"ticket_icon__1lu5n","content":"ticket_content__2nO2o"};